import { connect } from "react-redux";
import FirstInteractionForm from "./firstInteractionForm";
import { bindActionCreators } from "redux";
import {
  firstInteractionChecklist,
  postFirstInteractionCheckList
} from "services/redux/installation/civilCheckList/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  firstInteraction: state.civilReducer.firstInteractionForm,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      firstInteractionChecklist,
      getGateInfo,
      documentUploadUrl,
      postFirstInteractionCheckList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FirstInteractionForm);
